import React, { useState } from 'react'
// import ApiCalendar from '../../services/google-calendar'
import { ILiveWorkout, LiveConfig } from '../../types'
import { navigate } from 'gatsby'
import { LIVE_VIDEO_ROUTE, MORE_ROUTE } from '../../constants/routes'
import Button from '@material-ui/core/Button'
import LockIcon from '@material-ui/icons/Lock'
import { isMobile } from 'react-device-detect'
// import { DateTime } from 'luxon'

import Snackbar from '@material-ui/core/Snackbar'
import PurchaseModal from './PurchaseModal'
import SubscriptionModal from './SubscriptionModal'
import * as session from '../../util/session'
import { purchaseLiveClass } from '../../services/fetch/workouts'
import { getDisplayPrice } from '../../services/currency-codes'
import ConfirmPurchaseModal from './confirmPurchaseModal'
import { useTaxRates } from '../../hooks/useTaxRates'

interface Props {
  workout: ILiveWorkout
  isLocked: boolean
  isTrainer: boolean
  userSignedUp: boolean
  userHasAccess: boolean
  handlePurchase: (workout: ILiveWorkout) => void
  liveConfig: LiveConfig
}

const GATSBY_PURCHASE_LIVE_TOGGLE =
  process.env.GATSBY_PURCHASE_LIVE_TOGGLE === 'true' ? true : false

const JoinButton = ({
  userSignedUp,
  isTrainer,
  workout,
  handlePurchase,
  liveConfig,
  userHasAccess,
}: Props) => {
  // const [openDialog, setOpenDialog] = useState(false)
  const [openSnackbar, setOpenSnackbar] = useState(false)
  const [openBuyModal, setOpenBuyModal] = useState(false)
  const [openSubModal, setOpenSubModal] = useState(false)
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const [purchasing, setPurchasing] = useState(false)
  const { tax } = useTaxRates()

  const handleJoin = () => {
    if (workout.workoutVideoFormat === 'zoomLink' && window.open) {
      window.open(workout.zoomLink, '_blank')
    } else {
      navigate(LIVE_VIDEO_ROUTE(workout.id))
    }
  }

  // const handleClose = () => {
  //   setOpenDialog(false)
  // }

  // const createEvent = () => {
  //   const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

  //   const event = {
  //     summary: workout.title,
  //     description: workout.description,
  //     creator: workout.trainer && {
  //       id: workout.trainer.id,
  //       email: workout.trainer.email,
  //       displayName: `${workout.trainer.firstName} ${workout.trainer.lastName}`,
  //       self: false,
  //     },
  //     start: {
  //       dateTime: workout.startDate,
  //       timeZone,
  //     },
  //     end: {
  //       dateTime: DateTime.fromISO(workout.startDate)
  //         .plus({ minutes: workout.length })
  //         .toISO(),
  //       timeZone,
  //     },
  //   }

  //   if (!ApiCalendar.sign && !userSignedUp && !isTrainer) {
  //     ApiCalendar.handleAuthClick(event, () => setOpenSnackbar(true))
  //   }

  //   if (ApiCalendar.sign) {
  //     ApiCalendar.createEvent(event, () => setOpenSnackbar(true))
  //   }

  //   handleClose()
  // }

  const isLoggedIn = session.isLoggedIn()
  const subscriptionActiveOrTrialing = userHasAccess

  const handleMainButtonClick = () => {
    if (isTrainer) {
      handleJoin()
    } else {
      if (userSignedUp) {
        handleJoin()
        return
      }

      if (GATSBY_PURCHASE_LIVE_TOGGLE) {
        if (
          isLoggedIn &&
          subscriptionActiveOrTrialing &&
          workout.isForSale &&
          !workout.isIncludedInMembership
        ) {
          setOpenConfirmDialog(true)
          return
        }

        if (isLoggedIn && subscriptionActiveOrTrialing) {
          handlePurchase(workout)
          return
        }

        if (isLoggedIn && !subscriptionActiveOrTrialing && !workout.isForSale) {
          navigate(MORE_ROUTE)
          return
        }

        if (isLoggedIn && !subscriptionActiveOrTrialing && workout.isForSale) {
          setOpenConfirmDialog(true)
          return
        }

        if (!isLoggedIn && workout.isForSale) {
          setOpenBuyModal(true)
          return
        }

        if (!isLoggedIn && !workout.isForSale) {
          setOpenSubModal(true)
          return
        }
      }

      if (isLoggedIn && subscriptionActiveOrTrialing) {
        handlePurchase(workout)
        return
      } else {
        setOpenSubModal(true)
        return
      }
    }

    // if (!isTrainer && !userSignedUp) {
    //   // setOpenDialog(true)
    // } // else {
    // // joinOrSchedule()
    // // }
  }

  const classPriceObj =
    workout.isForSale &&
    liveConfig &&
    liveConfig.liveWorkoutPrices.find(
      price => price.priceId === workout.priceId,
    )

  const priceAmount = classPriceObj && classPriceObj.amount
  const currency = classPriceObj && classPriceObj.currency

  const getButtonText = () => {
    if (isTrainer) {
      return 'Join'
    } else {
      if (userSignedUp) {
        return 'Join'
      }

      if (GATSBY_PURCHASE_LIVE_TOGGLE) {
        if (userSignedUp) {
          return 'Join'
        }

        if (
          isLoggedIn &&
          subscriptionActiveOrTrialing &&
          workout.isForSale &&
          !workout.isIncludedInMembership
        ) {
          return `Buy ${getDisplayPrice(priceAmount, currency, true)}`
        }

        if (isLoggedIn && !subscriptionActiveOrTrialing && workout.isForSale) {
          return `Buy ${getDisplayPrice(priceAmount, currency, true)}`
        }

        if (!isLoggedIn && workout.isForSale) {
          return `Buy ${getDisplayPrice(priceAmount, currency, true)}`
        }

        if (isLoggedIn && !subscriptionActiveOrTrialing && !workout.isForSale) {
          return 'Buy Membership'
        }

        if (isLoggedIn && subscriptionActiveOrTrialing) {
          return 'Schedule'
        }

        if (!isLoggedIn && !workout.isForSale) {
          return 'Schedule'
        }
      }
      return userSignedUp ? 'Join' : 'Schedule'
    }
  }

  const handleBuyClass = () => {
    setPurchasing(true)
    const taxId = tax ? tax.id : undefined
    purchaseLiveClass(workout.id, workout.priceId, taxId)
      .then(() => {
        setOpenConfirmDialog(false)
        setPurchasing(false)
        window.location.reload()
      })
      .catch(err => {
        // TODO handle errors
        console.log('err', err)
      })
  }

  const shouldBeLockedFunc = () => {
    if (isTrainer) {
      return false
    }
    if (
      isLoggedIn &&
      !subscriptionActiveOrTrialing &&
      !GATSBY_PURCHASE_LIVE_TOGGLE
    ) {
      return true
    }
    return false
  }

  const shouldBeLocked = shouldBeLockedFunc()

  return (
    <>
      <Button
        variant={userSignedUp || isTrainer ? 'contained' : 'outlined'}
        color="primary"
        startIcon={shouldBeLocked ? <LockIcon /> : null}
        disabled={shouldBeLocked}
        id={`joinButton${workout.title}`}
        onClick={() => handleMainButtonClick()}
        style={{
          textTransform: 'capitalize',
          width: isMobile ? 80 : 130,
        }}
      >
        {getButtonText()}
      </Button>

      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        open={openSnackbar}
        onClose={() => setOpenSnackbar(false)}
        message="Calendar event created"
        autoHideDuration={4000}
      />
      {liveConfig && (
        <PurchaseModal
          open={openBuyModal}
          handleClose={() => setOpenBuyModal(false)}
          workout={workout}
          liveConfig={liveConfig}
        />
      )}

      <SubscriptionModal
        open={openSubModal}
        handleClose={() => setOpenSubModal(false)}
        workout={workout}
      />

      <ConfirmPurchaseModal
        openConfirmDialog={openConfirmDialog}
        handleBuyClass={handleBuyClass}
        setOpenConfirmDialog={setOpenConfirmDialog}
        purchasing={purchasing}
        workout={workout}
        amount={priceAmount}
        currency={currency}
        tax={tax}
      />

      {/* <Dialog
        open={openDialog ? true : false}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Create google calendar event ?
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            We can create a calendar event for you, if you give us permissions
            to create events in google calendar.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            No, thanks
          </Button>
          <Button
            onClick={createEvent}
            color="primary"
            autoFocus
            variant="contained"
          >
            Create Event
          </Button>
        </DialogActions>
      </Dialog> */}
    </>
  )
}

export default JoinButton
